import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';
import { Badge } from '../catalyst/badge';
import backend from '../services/backend';
import { Link } from './Link';
import { overallState, stageTotals, STATE_BADGE } from '../pages/monitoring/helpers';

const REFRESH_INTERVAL = 15_000;

export default function PipelineHealthStrip({ className }: { className?: string }) {
  const { data } = useQuery({
    queryKey: ['pipelineStatusStrip'],
    queryFn: () => backend.getPipelineStatus().then((res) => res.data),
    refetchInterval: REFRESH_INTERVAL,
  });

  if (!data) return null;

  const state = STATE_BADGE[overallState(data.stages)];
  const totals = stageTotals(data.stages);

  return (
    <div
      className={clsx(
        'flex items-center gap-3 rounded-lg border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-800 dark:shadow-zinc-950/30 px-4 py-3',
        className,
      )}
    >
      <h3 className="text-sm font-medium text-gray-900 dark:text-zinc-100">Pipeline</h3>
      <Badge color={state.color}>{state.label}</Badge>
      <span className="text-sm text-gray-500 dark:text-zinc-400">
        {totals.queued} queued · {totals.ratePerMin}/min · {totals.instances} instances
      </span>
      <Link to="/monitoring" className="ml-auto text-sm font-medium">
        View pipeline →
      </Link>
    </div>
  );
}
